import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PortalLayout from "@/layouts/PortalLayout";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";

export default function PressReleases() {
  const { t } = useLang();
  const [list, setList] = useState([]);
  const [sort, setSort] = useState("published_at-desc");

  useEffect(() => {
    const [s, o] = sort.split("-");
    api.get("/news", { params: { category: "Communiqué", sort: s, order: o } })
      .then((r) => setList(r.data))
      .catch(() => {});
  }, [sort]);

  return (
    <PortalLayout sidebar="press">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-3xl font-bold text-navy md:text-4xl">{t("press_pressreleases_01")}</h1>
        <select value={sort} onChange={(e) => setSort(e.target.value)} className="rounded-full border border-neutral-200 bg-white px-4 py-2 text-sm" data-testid="press-releases-sort">
          <option value="published_at-desc">{t("press_pressreleases_02")}</option>
          <option value="published_at-asc">Plus anciens d&apos;abord</option>
          <option value="title-asc">Titre A → Z</option>
          <option value="title-desc">Titre Z → A</option>
        </select>
      </div>
      <div className="mt-8 grid gap-5 md:grid-cols-2">
        {list.map((n) => (
          <Link key={n.id} to={`/news/${n.slug}`} className="rounded-2xl border border-neutral-100 bg-white p-5 hover:-translate-y-1 hover:shadow-md transition-all" data-testid={`press-release-${n.id}`}>
            <span className="inline-block rounded-full bg-wine-50 px-2.5 py-1 text-xs font-semibold uppercase tracking-wider text-wine-700">{n.category}</span>
            <h3 className="mt-3 font-serif text-lg text-neutral-900">{n.title}</h3>
            <p className="mt-2 line-clamp-2 text-sm text-neutral-600">{n.excerpt}</p>
            <div className="mt-3 text-xs text-neutral-500">{n.published_at && new Date(n.published_at).toLocaleDateString("fr", { dateStyle: "long" })}</div>
          </Link>
        ))}
        {list.length === 0 && <div className="md:col-span-2 rounded-2xl border border-dashed border-neutral-200 bg-white p-10 text-center text-sm text-neutral-500">{t("press_pressreleases_03")}</div>}
      </div>
    </PortalLayout>
  );
}
